import { rgba } from "polished";
import styled, { css, keyframes } from "styled-components";
import { FlexMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../styles/common/mixins/logical.styled.js";
const pulseKeyframe = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
`;
const waveKeyframe = keyframes`
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
`;
const variantStyles = (variant = 'rectangular')=>({
        circular: css`
			${BorderRadius({
            all: '50%'
        })}
		`,
        rectangular: css`
			${BorderRadius({
            all: '0'
        })}
		`,
        rounded: css`
			${BorderRadius({
            all: '5px'
        })}
		`,
        text: css`
			${BorderRadius({
            all: '5px'
        })}
			height: auto;
			margin-bottom: 0;
			margin-top: 0;
		`
    })[variant];
export const animationStyles = (animation = 'pulse')=>({
        pulse: css`
			animation: ${pulseKeyframe} 1.5s ease-in-out 0.5s infinite;
		`,
        wave: css`
			position: relative;
			overflow: hidden;

			&::after {
				animation: ${waveKeyframe} 1.6s linear 0.5s infinite;
				background: linear-gradient(90deg, transparent, var(--skeleton-color-effect), transparent);
				content: '';
				bottom: 0;
				left: 0;
				mask-image: radial-gradient(
					${(props)=>props.theme.colors.white.base},
					${(props)=>props.theme.colors.black.base}
				);
				position: absolute;
				right: 0;
				top: 0;
				transform: translateX(-100%);
			}
		`
    })[animation];
export const Skeleton = styled.div.withConfig({
    displayName: "styled__Skeleton",
    componentId: "sc-59de16f4-0"
})`
	--skeleton-color-base: ${({ theme , $color ={
    base: theme.colors.black.higher
}  })=>$color.base};
	--skeleton-color-effect: ${({ theme , $color ={
    effect: theme.colors.black.base
} , opacity =0.04  })=>rgba($color.effect, opacity)};

	${({ animation  })=>animationStyles(animation)}
	${({ variant  })=>variantStyles(variant)}
	${FlexMixin({})}
	background-color: var(--skeleton-color-base);
	min-height: 20px;
`;

//# sourceMappingURL=styled.js.map